import React, { useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl, IntlShape } from 'react-intl';
import { Box } from '@material-ui/core';
import ChevronCardButtonList from 'components/ChevronCardButtonList';
import { StyledPaper, StyledShortBody } from 'containers/MyAccountPage/styles';
import { sanlamVeryLightgray, sanlamDarkGrayishBlue } from 'Material-UI/colors';
import CardHeader from 'containers/MyAccountPage/CardHeader';
import { translate } from 'helpers/intl';
import get from 'lodash/get';
import messages from 'containers/MyAccountPage/messages';
import PAGES from 'routes/pages';
import ReportABugModal from 'components/ReportABugModal';
import { isReportBugLoadingSelector } from 'store/global/selectors';
import { reportBug } from 'store/global/actions';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

const About = (props: AboutType) => {
  const [isReportABugModalOpen, setIsReportABugModalOpen] = useState(false);

  const aProposItems = [
    {
      title: (
        <GaClickHOC category={EVENT_CATEGORIES.SETTINGS} label="CGU">
          <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
            {translate(get(messages, 'generalConditions'), props)}
          </StyledShortBody>
        </GaClickHOC>
      ),
      icon: 'fileIcon',
      path: PAGES.LEGAL_NOTICE,
    },
    {
      title: (
        <GaClickHOC
          category={EVENT_CATEGORIES.SETTINGS}
          label="Signaler un bug"
        >
          <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
            {translate(get(messages, 'reportABug'), props)}
          </StyledShortBody>
        </GaClickHOC>
      ),
      icon: 'alertTriangle',
      action: /* istanbul ignore next */ () => setIsReportABugModalOpen(true),
    },
  ];

  return (
    <>
      <CardHeader
        title={translate(get(messages, 'about'), props)}
        icon="settingsInfo"
      />
      <StyledPaper>
        <Box pt={4} px={3} pb={3}>
          <ChevronCardButtonList
            borderColor={sanlamVeryLightgray}
            items={aProposItems}
            spacing={2}
            deleteHoverBorder={true}
            direction="column"
          />
        </Box>
      </StyledPaper>
      <ReportABugModal
        handleClose={
          /* istanbul ignore next */ () => setIsReportABugModalOpen(false)
        }
        isLoading={props.isReportBugLoading}
        isOpen={isReportABugModalOpen}
        reportABug={props.reportBug}
      />
    </>
  );
};
export interface AboutType {
  intl: IntlShape;
  isReportBugLoading: boolean;
  reportBug: Function;
}

const mapStateToProps = createStructuredSelector<
  any,
  {
    isReportBugLoading: boolean;
  }
>({
  isReportBugLoading: isReportBugLoadingSelector,
});

const mapDispatchToProps = {
  reportBug,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(About));

export const AboutTest = injectIntl(About);
